/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import React, { useEffect, useState } from 'react'
import fetchFilterData from 'api/search'

import { Subway as SubwayGeneric } from 'components/generic/dropdown/Subway'

export function Subway({ data }) {
  const [selectedLines, setSelectedLines] = useState(
    data?.subway_id_list?.split(',').filter(item => item && item.trim()) || []
  )
  const [selectedStops, setSelectedStops] = useState(
    data?.subway_stop_list?.split(',').filter(item => item && item.trim()) || []
  )

  useEffect(() => {
    setSelectedLines(data?.subway_id_list?.split(',').filter(item => item && item.trim()) || [])
    setSelectedStops(data?.subway_stop_list?.split(',').filter(item => item && item.trim()) || [])
  }, [data])

  const [filterData, setFilterData] = useState({
    subways: [],
    subwayStops: [],
  })

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchFilterData().then((results) => {
      setFilterData(results)
      setLoading(false)
    })
  }, [])

  return (
    <SubwayGeneric
      value={{
        subwayLines: selectedLines,
        subwayStops: selectedStops,
      }}
      onChange={{
        onLineChange: (x) => {
          const values = x?.join(',')
          const subwayLinesInput = document.querySelector('#listing-subway-values')
          setSelectedLines(x)
          if (subwayLinesInput) {
            subwayLinesInput.setAttribute('value', values)
          }
        },
        onStopChange: (x) => {
          const values = x?.subwayStops?.join(',')
          const subwayStopsInput = document.querySelector('#listing-subway-stop-values')
          setSelectedStops(x?.subwayStops)
          if (subwayStopsInput) {
            subwayStopsInput.setAttribute('value', values)
          }
        },
      }}
      loading={loading}
      options={{
        subwayLines: filterData.subwayLines,
        subwayStops: filterData.subwayStops,
      }}
    />
  )
}
